import React from 'react';

const MiniClaim = () => {
  return (
    <section className="py-10 bg-[#172A45] text-white">
      <div className="container mx-auto px-4">
        <p className="text-center text-[#64FFDA] text-lg lg:text-2xl font-bold">
          Real infrastructure. Real responsibility. Proven results.
        </p>
      </div>
    </section>
  );
};

export default MiniClaim;
